/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  Permission,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    PermissionFromJSON,
    PermissionToJSON,
} from '../models/index';

/**
 * 
 */
export class PermissionsApi extends runtime.BaseAPI {

    /**
     * Retrieve all permissions of user in jwt token.
     * List all permissions of user
     */
    async getPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Permission>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PermissionFromJSON));
    }

    /**
     * Retrieve all permissions of user in jwt token.
     * List all permissions of user
     */
    async getPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Permission>> {
        const response = await this.getPermissionsRaw(initOverrides);
        return await response.value();
    }

}
